import { render, staticRenderFns } from "./HomeCES.vue?vue&type=template&id=2baf2fdb&"
import script from "./HomeCES.vue?vue&type=script&lang=ts&"
export * from "./HomeCES.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports